/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StateOfUse = {
    Enabled: 'Enabled',
    InEditing: 'InEditing',
    Disabled: 'Disabled'
} as const;
export type StateOfUse = typeof StateOfUse[keyof typeof StateOfUse];


export function StateOfUseFromJSON(json: any): StateOfUse {
    return StateOfUseFromJSONTyped(json, false);
}

export function StateOfUseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StateOfUse {
    return json as StateOfUse;
}

export function StateOfUseToJSON(value?: StateOfUse | null): any {
    return value as any;
}

/**
 * Check if a given object implements the StateOfUse interface.
 */
 export function instanceOfStateOfUse(value: any): value is StateOfUse {
    return Object.values(StateOfUse).includes(value)
}

